const convertDateToTimezone = (date, timezone) => {
  return new Date(date).toLocaleString(
    'en-US',
    { timeZone: timezone },
  );
};

export default convertDateToTimezone;
